import React from "react";
import { ReactController } from "../react_controller";
import { FacilityDaySchedule } from "../../components/Calendar/FacilityDaySchedule";

export class AdminFacilityDayScheduleController extends ReactController {
  connect() {
    this.root.render(<FacilityDaySchedule {...this.propsValue} />);
  }
}
